module.exports = __webpack_public_path__ + "img/hor_loterialockup.8704f5e6.b463552d.png";